export default __webpack_public_path__ + "static/media/OCEAN.5b44b93d.svg";